export default __webpack_public_path__ + "static/media/close.d93040a3.svg";